import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DmsService } from '../../shared/services/dms.service';
import { ToastService } from '../../shared/services/toast.service';

@Component({
  selector: 'app-dms-export',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dms-export.component.html',
})
export class DmsExportComponent implements OnDestroy {
  public isSyncing = false;
  private subscriptions = new Subscription();

  constructor(
    private dmsService: DmsService,
    private toastService: ToastService
  ) { }

  public triggerDmsSync(): void {
    this.isSyncing = true;
    this.subscriptions.add(
      this.dmsService.sync().subscribe({
        next: () => {
          this.toastService.showSuccess('Synchronisierung gestartet');
          this.isSyncing = false;
        },
        error: () => {
          this.toastService.showError('Synchronisierung fehlgeschlagen');
          this.isSyncing = false;
        },
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
